import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useDisciplineTasksStore, TUTOR_TASKS_ARRAY_QUERY_KEYS, getCanonicalTutorTasksQuery, queryToTutorTasksFilters } from '@pages/discipline'
import { useListsStore } from '@shared/model'
import { MAX_PER_PAGE, toPaginationValue } from '@shared/lib/routes'
import { foldBracketArrayParams } from '@shared/lib/url'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

/**
 * `/disciplines/{id}/tasks` — query → store filters, as `middleware/surveys.ts` does. A query the filters
 * cannot show (app-main's `status[0]=…`, a CANCELED status without an actor) is rewritten once, so the URL,
 * the controls and the request always agree.
 */
export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalizedGeneric) => {
  const foldedQuery = foldBracketArrayParams(to.query, TUTOR_TASKS_ARRAY_QUERY_KEYS)
  const query = foldedQuery ?? to.query

  const lists = await useListsStore().ensure()
  const filters = queryToTutorTasksFilters(query, lists?.tutor_task ?? null)
  const canonicalQuery = getCanonicalTutorTasksQuery(query, filters)

  if (foldedQuery || canonicalQuery) {
    return navigateTo({ path: to.path, query: canonicalQuery ?? query }, { replace: true })
  }

  const store = useDisciplineTasksStore()

  store.setFilters(filters)
  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, store.getPerPage, MAX_PER_PAGE))
  store.closeModal()
})
